import { CurrencyPipe, NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Product, ProductVariant } from 'src/app/classes/utility';
import { ProductService } from '../../../product.service';

@Component({
  selector: 'app-price',
  imports: [NgIf, CurrencyPipe, NgClass],
  templateUrl: './price.component.html',
  styleUrl: './price.component.scss',
})
export class PriceComponent {
  @Input() product!: Product;

  _selectedVariant!: ProductVariant;
  constructor(private productService: ProductService) {
    this.productService.variantObservable.subscribe((data) => {
      this._selectedVariant = data;
    });
  }
}
